export enum MediaTypes {
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO',
}
